// extracted by mini-css-extract-plugin
export default {"textLabel":"BillingForm_textLabel__Rhl3S","mainTitle":"BillingForm_mainTitle__vJmWh"};